/* eslint-disable react-hooks/exhaustive-deps */
import React from 'react'
import { useState } from 'react';
import { useEffect } from 'react'

const styles = {
    modal: {
        "background-color": "#005b80",
        // "position": "absolute",
        "padding": "20px",
        "width": "600px",
        "border-radius": "20px",
        "boxShadow": "rgb(0 0 0 / 15%) 0px 0px 10px 10px"
    },
    cta: {
        "display": "flex",
        "justify-content": "flex-end"
    }
}

const TutorialModel = ({ title, description, top, bottom, left, right, onNext, className }) => {
    const [previousClassName, setPreviousClassName] = useState();
    useEffect(() => {
        if (className) {
            document.getElementsByClassName(className)[0].classList.add('pulse-border');
            document.getElementsByClassName(previousClassName)[0]?.classList.remove('pulse-border');
            setPreviousClassName(className);
        }
        if (!className && !title) {
            document.getElementsByClassName(previousClassName)[0]?.classList.remove('pulse-border');
        }
    }, [className])
    if (!title) {
        return null;
    }
    return (
        <div style={{ "position": "absolute", top, bottom, left, right, }}>
            {/* <div className="arrow-right" style={{ "position": "absolute", left: "420px" }} ></div> */}
            <div style={{ ...styles.modal }}>
                <h2>{title}</h2>
                <pre style={{ "whiteSpace": "pre-wrap" }}><p>{description}</p></pre>
                <div style={styles.cta}>
                    <button onClick={onNext}>next</button>
                </div>
            </div>
            {/* <div className="arrow-down" ></div> */}
        </div>
    )
}

export default TutorialModel